<script lang="ts">
  import { Link } from '@athena-lib/Link';
  import type { SocialMediaIconsProps } from './types';

  const { socialMediaIcons, action }: SocialMediaIconsProps = $props();

  function elementAction(node: HTMLDivElement, actionArg: unknown) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div class="mt-10 flex items-center justify-between">
  {#key socialMediaIcons}
    {#each socialMediaIcons as socialMediaIcon}
      <Link {...socialMediaIcon.link}>
        <img
          src={socialMediaIcon.icon.url}
          alt={socialMediaIcon.icon.alt}
          loading="lazy"
          use:elementAction={socialMediaIcon.actionArg}
        />
      </Link>
    {/each}
  {/key}
</div>
